import { gql } from '@apollo/client';

const BUY_DATABUNDLE = gql`
   mutation BuyDataBundle($itemCode: String!, $phonenumber: String!, $amount: Float!, $network: String!) {
    buyDataBundle(itemCode: $itemCode, phonenumber: $phonenumber, amount: $amount, network: $network) {
            message
            success
        }
    }
`

const BUY_BULK_DATA = gql`
    mutation BuyBulkData($userId: ID!, $phonenumbers: [DataBundleInput!]) {
        buyBulkData(userId: $userId, phonenumbers: $phonenumbers) {
            message
            success
        }
    }
`

export {
    BUY_DATABUNDLE,
    BUY_BULK_DATA
}